import get from 'lodash/get';

export const selectCurrentWorkspace = (state) => get(state, 'faraday.workspaceSelected', '');
export const selectShowWorkspaceValidator = (state) => get(state, 'faraday.showWorkspaceValidator', false);
export const selectEmail = (state) => get(state, 'faraday.email', '');
export const selectUrlReturn = (state) => get(state, 'faraday.urlReturn', ''); // url que determina a donde ir luego de loguearse.
export const selectIsAdmin = (state) => get(state, 'faraday.role', '') === 'admin';
export const selectUserName = (state) => get(state, 'faraday.userName', '');
export const selectApiVersion = (state) => get(state, 'faraday.apiVersion', '');
export const selectWsPort = (state) => get(state, 'faraday.wsPort', 0);
